import { axios } from '@/utils/request'

const api = {
  dakejianList: '/wyhadminapi/cdakejian/dakejianList',
  dakejianDetail: '/wyhadminapi/cdakejian/dakejianDetail',
  editDakejian: '/wyhadminapi/cdakejian/editDakejian',
  deleteDakejian: '/wyhadminapi/cdakejian/dakejianDelete',
  dakejianDeleteAll: '/wyhadminapi/cdakejian/dakejianDeleteAll',
  dakejianDownloadUrl: '/wyhadminapi/cdakejian/dakejianDownloadUrl',
  setShoupaiAll: '/wyhadminapi/cdakejian/setShoupaiAll',
}

export default api

export function getDakejianList(parameter) {
  return axios({
    url: api.dakejianList,
    method: 'get',
    params: parameter
  })
}

export function getDakejianDetail(parameter) {
  return axios({
    url: api.dakejianDetail,
    method: 'get',
    params: parameter
  })
}
export function editDakejian(parameter) {
  return axios({
    url: api.editDakejian,
    method: 'post',
    data: parameter
  })
}
export function deleteDakejian(parameter) {
  return axios({
    url: api.deleteDakejian,
    method: 'post',
    data: parameter
  })
}

export function dakejianDeleteAll(parameter) {
  return axios({
    url: api.dakejianDeleteAll,
    method: 'post',
    data: parameter
  })
}

export function getCDakejianDownloadUrl(parameter) {
  return axios({
    url: api.dakejianDownloadUrl,
    method: 'post',
    data: parameter
  })
}
export function setShoupaiAll(parameter) {
  return axios({
    url: api.setShoupaiAll,
    method: 'post',
    data: parameter
  })
}